import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons"
import * as Colors from "../../../styles/colors"
import * as Fonts from "../../../styles/typography"

export default function Item({ title, icon, onPress }) {
    return (<TouchableOpacity style={styles.view} onPress={onPress}>
        <Icon name={icon} size={64}  color={Colors.BLACK}/>
        <Text style={styles.title}>{title}</Text>
    </TouchableOpacity>)
}

const styles = StyleSheet.create({
    view: {
        //   flexDirection: "row",
        alignItems: "center",
        marginVertical: 4,
        backgroundColor: "#ffffff",
        padding: 8,
        borderColor: Colors.SECONDARY,
        borderLeftWidth: 2,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        borderRadius: 8,
        width: "45%",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
    },
    title: {
        fontSize: Fonts.FONT_SIZE_16,
        color: Colors.BLACK
    }
});